module.exports = __webpack_public_path__ + "assets/images/age_y.e6d0730c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/age_y.png
// module id = 674
// module chunks = 1